<template>
  <section class="col-sm-12 col-lg-12 form-group pt-3 mt-2">
    <div class="col-sm-12 col-md-12 form-group text-left pb-0 mb-0">
      <p
        class="text-center text-uppercase"
        :style="template.secondaryTheme ? 'color: white;' : ''"
        style="font-size: 1rem; line-height: 24px"
      >
        Definição de senha
      </p>
    </div>

    <!-- Error -->
    <div v-if="errors.length" class="col form-group">
      <div class="mb-1 mt-2 p-2 c-errors">
        <p class="fontMenor mb-2" :style="template.secondaryTheme ? 'color: white;' : ''">
          <strong>
            {{ errors[0].title }}
          </strong>
          <br />
          {{ errors[0].msg }}
        </p>
      </div>
    </div>

    <p
      class="col fontMenor my-5 text-center"
      style="word-break: break-word"
      :style="template.secondaryTheme ? 'color: white;' : ''"
    >
      Insira sua nova senha
    </p>

    <div class="col form-group mt-5">
      <input
        id="password"
        ref="pwInput"
        class="w-100 c-input"
        placeholder="Senha"
        :style="{ borderColor: template.inputBorderColor }"
        :type="showPassword ? 'text' : 'password'"
        @keyup="errors = []"
      />

      <span class="input-show-pass pt-2 mr-4" @click="showPassword = !showPassword">
        <i class="fa fa-eye senhaIcon" :class="showPassword ? 'fa-eye' : 'fa-eye-slash'" />
      </span>
    </div>

    <div class="col form-group mt-5 mb-4">
      <input
        id="confirmPassword"
        ref="pwConfirmInput"
        class="w-100 c-input"
        placeholder="Confirme a senha"
        :style="{ borderColor: template.inputBorderColor }"
        :type="showPassword2 ? 'text' : 'password'"
        @keyup="errors = []"
      />

      <span class="input-show-pass pt-2 mr-4" @click="showPassword2 = !showPassword2">
        <i class="fa fa-eye senhaIcon" :class="showPassword2 ? 'fa-eye' : 'fa-eye-slash'" />
      </span>
    </div>

    <p class="pl-3" style="font-size: 0.7rem">
      <small :style="template.secondaryTheme ? 'color: white;' : ''"
        >* Pelo menos 8 caracteres.</small
      >

      <br />

      <small :style="template.secondaryTheme ? 'color: white;' : ''"
        >* Pelo menos 1 caractere especial.</small
      ><br />

      <small :style="template.secondaryTheme ? 'color: white;' : ''">* Pelo menos 1 número.</small>
    </p>

    <!-- Buttons -->
    <div class="col-sm-12 col-md-12 form-group mt-3 pt-2">
      <button
        class="btn btn-block shadow-sm btnStock btn"
        :style="primaryBtnStyle"
        type="submit"
        @click="salvarSenha"
      >
        SALVAR
      </button>

      <button
        class="btn btn-block shadow-sm btnStock btn mt-3"
        :style="secondaryBtnStyle"
        @click="$router.push('/login')"
      >
        CANCELAR
      </button>
    </div>
  </section>
</template>

<script>
/* Services */
import { loginFB } from '../../services/ServFB.js'

/* State */
import { mapState, mapGetters } from 'vuex'

const lFB = new loginFB()

export default {
  name: 'Senha',
  data: () => ({
    errors: [],
    showPassword: false,
    showPassword2: false,
  }),
  computed: {
    token() {
      return this.$route.query.tk
    },
    ...mapGetters(['primaryBtnStyle', 'secondaryBtnStyle']),
    ...mapState(['template', 'config', 'subdomain']),
  },
  mounted() {
    document.getElementById('password').focus()
  },
  methods: {
    salvarSenha() {
      if (this.$refs.pwInput.value !== this.$refs.pwConfirmInput.value) {
        this.errors.push({
          type: 'password',
          title: 'Senhas diferentes',
          msg: 'Por favor, redigite as senhas.',
          details: '',
        })
      } else if (this.$refs.pwInput.value.length < 6) {
        this.errors.push({
          type: 'password',
          title: 'Sua senha é muito curta',
          msg: 'Por favor, redigite as senhas com no mínimo 8 caracteres.',
          details: '',
        })
      } else {
        this.postPwd()
      }
    },
    postPwd() {
      const data = {
        token: this.token,
        password: this.$refs.pwInput.value,
      }

      lFB
        .newAccountPassword(data)
        .then(() => {
          this.$emit('component', 'msg-completo')
        })
        .catch(err => {
          console.error(err)
          const tokenErrorMsg =
            'Ocorreu um erro ao redefinir senha. Solicite novamente a redefinição de senha.'
          const ArrayTokenKeywords = ['Token', 'PII', 'Jwt']
          const isTokenError = ArrayTokenKeywords.some(keyword => err.includes(keyword))

          this.errors.push({
            type: 'post',
            title: 'Erro ao enviar solicitação',
            msg: isTokenError ? tokenErrorMsg : err,
          })
        })
    },
  },
}
</script>
